/** Minimum width per bar in pixels — used for scroll container sizing */
export const BAR_MIN_WIDTH_PX = 144;

/**
 * Chart area height in pixels.
 * BarChart uses the equivalent Tailwind class `h-[300px]` — keep both in sync.
 */
export const CHART_HEIGHT_PX = 300;

/** Character length above which a badge label gets a hover tooltip */
export const BADGE_TOOLTIP_THRESHOLD = 16;

/** Delay in ms before tooltips appear on hover */
export const TOOLTIP_DELAY_MS = 200;

/** Tailwind class for the Y-axis column width */
export const Y_AXIS_WIDTH_CLASS = 'w-12';
